import React from 'react';

import UploadError from './UploadError';
import UploadingInfo from './UploadingInfo';

interface FileRowProps {
  fields?: {
    [key: string]: string;
  };
  file: {
    [key: string]: any;
  };
  onFileDelete: (...args: unknown[]) => unknown;
  onFileError: (...args: unknown[]) => unknown;
}

const FileRow = (props: FileRowProps) => {
  props = {
    ...props,
    fields: typeof props.fields === 'undefined' ? {} : props.fields
  };

  const { file } = props;
  if (file.error) return <UploadError {...props} />;
  if (file.filename && !file.deletedOn) return <UploadingInfo {...props} />;
  return null;
};

export default FileRow;
